// extracted by mini-css-extract-plugin
export var pageFooter = "page-footer__JIJ6x";
export var pageFooterAnchored = "page-footer-anchored__xaKE4";